import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';

@Component({
    standalone: false,
    selector: 'app-compare-summary-rules-dialog',
  templateUrl: './compare-summary-rules-dialog.component.html',
  styleUrls: ['./compare-summary-rules-dialog.component.scss']
})
export class CompareSummaryRulesDialogComponent implements OnInit, IDialogView {
  data: DialogModel;

  latestSummaryRulesSnapshot: any;
  selectedSnapshot: any;
  selectedCountry: any;
  //
  summaryRulesSnapshots: any[] = [];
  publishedCountries: any[] = [];
  constructor(private platformQueryService: PlatformQueryService) { }

  ngOnInit() {
    this.data.isDisabledOkButton = true;
    const snapshotQueryCommand = new PlatformQuery();
    snapshotQueryCommand.name = 'SummaryRuleSnapshotQuery';
    snapshotQueryCommand.api = 'ChaptersApi';
    snapshotQueryCommand.fieldValues['SourceType'] = this.data.input['sourceType'];
    this.platformQueryService.executeQuery(snapshotQueryCommand).subscribe(response => {
      this.summaryRulesSnapshots = response.fieldValues['SummaryRuleSnapshots'];
      this.latestSummaryRulesSnapshot = response.fieldValues['LatestSummaryRuleSnapshot'];
    });
  }
  onOkClicked(): boolean {
    this.data.input['currentSnapshot'] = this.latestSummaryRulesSnapshot;
    this.data.input['previousSnapshot'] = this.selectedSnapshot;
    this.data.input['country'] = this.selectedCountry;
    return true;
  }
  onSelectPublicationDate(event) {
    this.selectedSnapshot = event.value;
    const summaryRuleQuery = new PlatformQuery();
    summaryRuleQuery.name = 'SummaryRuleBySnapshotIdQuery';
    summaryRuleQuery.api = 'ChaptersApi';
    summaryRuleQuery.fieldValues['LatestSnapshotId'] = this.latestSummaryRulesSnapshot.id;
    summaryRuleQuery.fieldValues['IncludeCountries'] = true;
    summaryRuleQuery.fieldValues['SnapshotId'] = this.selectedSnapshot.id;
    summaryRuleQuery.fieldValues['SourceType'] = this.selectedSnapshot.sourceType;
    this.platformQueryService.executeQuery(summaryRuleQuery).subscribe(response => {
      this.publishedCountries = response.fieldValues['Countries'];
    });
  }
  onSelectPublicationCountry(event) {
    this.selectedCountry = event.value;
    this.data.isDisabledOkButton = false;
  }
}
